module.exports = __webpack_public_path__ + "static/media/giorgio-armani-code-big.bd0ab958.png";